<div>
  <h6 class="odx-title-6" i18n="@@global.isolationRooms">Isolation rooms</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="isolation-room"
      (click)="addIsolationRoom()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragIsolationRoom()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.isolationRoomsVisible"
      (toggleEvent)="floorplanState.isolationRoomsVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.isolationRoomsItemTextVisible"
      (toggleEvent)="updateIsolationRoomsItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.isolationRoomsLocked"
      (toggleEvent)="floorplanState.isolationRoomsLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
